import styled, { css } from "styled-components";
import { colors, iconSize } from "shared/styles/constants";

interface IconProps {
  size?: keyof typeof iconSize;
  height?: string; // override size
  width?: string; // override size
  color?: colors;
  backgroundColor?: colors;
  isCircle?: boolean;
  padding?: string;
  cursor?: string;
}

const DEFAULT_ICON_SIZE = iconSize.m;

const getSize = (size1?: string, size2?: keyof typeof iconSize) => {
  if (size1) return size1;
  if (size2) return iconSize[size2];
  return DEFAULT_ICON_SIZE;
};

export const Icon = styled.span<IconProps>`
  height: ${({ size, height }) => getSize(height, size)} !important;
  width: ${({ size, width }) => getSize(width, size)} !important;

  color: ${({ color }) => color || "inherit"};

  flex-shrink: 0 !important;

  cursor: ${({ cursor }) => cursor || "default"};

  ${({ isCircle, backgroundColor, padding = "2px" }) =>
    isCircle &&
    css`
      background-color: ${backgroundColor} !important;

      border-radius: 50%;
      padding: ${padding};
    `}

  @media print {
    * {
      color: ${({ color }) => color || "inherit"} !important;
    }
  }
`;
